import { useCallback, useSyncExternalStore } from "react"

/** Whether a CSS media query matches, updating as it changes (resize, rotation). */
export function useMediaQuery(query: string, fallback = false): boolean {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const list = window.matchMedia?.(query)
            list?.addEventListener("change", onChange)
            return () => list?.removeEventListener("change", onChange)
        },
        [query],
    )
    return useSyncExternalStore(subscribe, () => window.matchMedia?.(query).matches ?? fallback)
}
